import { useInfiniteItemsFetchData } from '../useInfiniteItemsFetchData'
import { useInfiniteItemsLoadOnScroll } from '../useInfiniteItemsLoadOnScroll'

import { getApiParamsFromData } from './useInfiniteItemsLoader.utils'

export function useInfiniteItemsLoader({
  apiParams,
  checkIsLastPage,
  getApiParamsLoadNext = getApiParamsFromData,
  getData,
  getDataItems,
  getMergedItems,
  getPermissionsData,
  getTotalCountData,
  initialItems,
  observerOptions,
  setAdditionalData,
  thresholdEndIndex,
  toPreparedItems,
  withPagination,
  onChangeInitialized,
  onChangePermissions,
  onChangeTotalCount,
}) {
  const {
    hasError,
    hasMoreRef,
    items,
    loadingInitial,
    loadingMore,
    loadInitial,
    loadMore,
    pageNumRef,
    setItems,
    totalCount,
  } = useInfiniteItemsFetchData({
    apiParams,
    checkIsLastPage,
    getData,
    getDataItems,
    getMergedItems,
    getPermissionsData,
    getTotalCountData,
    initialItems,
    setAdditionalData,
    toPreparedItems,
    withPagination,
    onChangeInitialized,
    onChangePermissions,
    onChangeTotalCount,
  })

  const { getThresholdItemProps } = useInfiniteItemsLoadOnScroll({
    fetchData: loadMore,
    getApiParamsLoadNext,
    hasMoreRef,
    isLoadingMore: loadingMore,
    items,
    observerOptions,
    thresholdEndIndex,
  })

  return {
    getThresholdItemProps,
    hasError,
    hasMoreRef,
    items,
    loadingInitial,
    loadingMore,
    loadInitial,
    loadMore,
    pageNumRef,
    setItems,
    totalCount,
  }
}
